import Vue from 'vue';
import App from './App.vue';
import router from "./router/router.js";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/static/icons/iconfont.css';
import scroll from 'vue-seamless-scroll';
import './static/icons/iconfont.css';
import BaiduMap from 'vue-baidu-map';


Vue.use(scroll)
Vue.use(Antd)
Vue.use(ElementUI)
Vue.config.productionTip = false


Vue.use(BaiduMap, {
  ak: 'IP1DjYwOLaYFt8TMwjHWUYnqUQAChdG8'
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
